// foobar.js

const SETTINGS = {
    BREAKPOINTS : {
        SM: 768,
        MD: 992,
        LG: 1200
    },
    SCROLL_ANIMATION_BREAKPOINTS : { 
        XS: 25,
        SM: 25,
        MD: 25,
        LG: 25
    },
    PARALLAX : {
        DEFAULT_SPEED: 160 
    },
    PARALLAX_ZOOM: {
        MAX_ZOOM: 0.2
    }
}

export { SETTINGS };


// WEBPACK FOOTER //
// ../w-theme/ui/assets/js/settings.js